import React from 'react';
import { Calendar, MapPin } from 'lucide-react';
import { Badge } from './ui/badge';
import { portfolioData } from '../data/mock';

const Experience = () => {
  const { experience } = portfolioData;

  return (
    <section id="experience" className="section-padding">
      <div className="container mx-auto">
        {/* Section Header */}
        <div className="text-center mb-20">
          <span className="section-label">Career</span>
          <h2 className="section-title">
            Work <span className="text-accent">Experience</span>
          </h2>
        </div>

        {/* Experience Timeline */}
        <div className="max-w-4xl mx-auto space-y-12">
          {experience.map((exp) => (
            <div
              key={exp.id}
              className="p-8 rounded-2xl border transition-all"
              style={{
                background: 'var(--bg-card)',
                borderColor: 'var(--border)'
              }}
            >
              {/* Company Header */}
              <div className="mb-6">
                <h3 className="text-2xl font-bold mb-2" style={{ color: 'var(--text-primary)' }}>
                  {exp.role}
                </h3>
                <div className="flex flex-wrap items-center gap-4" style={{ color: 'var(--text-secondary)' }}>
                  <span className="font-semibold" style={{ color: 'var(--accent)' }}>{exp.company}</span>
                  {exp.client && (
                    <>
                      <span style={{ color: 'var(--text-muted)' }}>•</span>
                      <span>Client: {exp.client}</span>
                    </>
                  )}
                </div>
              </div>

              {/* Location & Period */}
              <div className="flex flex-wrap items-center gap-4 mb-6 text-sm" style={{
                color: 'var(--text-muted)',
                fontFamily: 'JetBrains Mono, monospace'
              }}>
                <div className="flex items-center gap-2">
                  <MapPin className="h-4 w-4" />
                  <span>{exp.location}</span>
                </div>
                <div className="flex items-center gap-2">
                  <Calendar className="h-4 w-4" />
                  <span>{exp.period}</span>
                </div>
              </div>

              {/* Projects */}
              <div className="space-y-6">
                {exp.projects.map((project, projIndex) => (
                  <div key={projIndex}>
                    <h4 className="text-lg font-semibold mb-3" style={{ color: 'var(--text-primary)' }}>
                      {project.name}
                    </h4>
                    <ul className="space-y-2">
                      {project.highlights.map((highlight, hlIndex) => (
                        <li key={hlIndex} className="flex items-start gap-3" style={{ color: 'var(--text-secondary)' }}>
                          <span style={{ color: 'var(--accent)' }}>▸</span>
                          <span className="leading-relaxed">{highlight}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>

              {/* Technologies */}
              <div className="mt-6 flex flex-wrap gap-2">
                {exp.technologies.map((tech, techIndex) => (
                  <span
                    key={techIndex}
                    className="px-3 py-1 rounded-full text-xs border"
                    style={{
                      borderColor: 'var(--border)',
                      color: 'var(--text-secondary)',
                      fontFamily: 'JetBrains Mono, monospace'
                    }}
                  >
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
